import colors from 'shared-tokens/utils/tokens/colors';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brpS = createBreakpoint('s');
const brpM = createBreakpoint('m');
const brpXS = createBreakpoint('xs');

export const mainCls = 'publisherCard';

export default {
  [mainCls]: {
    borderTop: '1px solid #d8dbdf',
    borderBottom: '1px solid #d8dbdf',
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '12px',
    marginRight: '12px',
    [brpM]: {
      rowGap: '16px',
      border: '1px solid #d8dbdf',
      flexDirection: 'row',
      marginLeft: '0',
      marginRight: '0',
      '&.maplist': {
        flexDirection: 'column',
        border: '0 none',
        borderRadius: 0,
        '& .publisherCard__logo': {
          margin: '0 auto',
        },
        '& .publisherCard__logo-and-name': {
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        },
        '& .publisherCard__title-address': {
          minWidth: 0,
        },
        '& .publisherCard__name': {
          marginTop: 16,
          textAlign: 'center',
        },
        '& .publisherCard__address': {
          textAlign: 'center',
          lineHeight: '18px',
        },
        '& .publisherCard__btns': {
          flexDirection: 'column',
        },
        '& .publisherCard__btns__link-a': {
          marginBottom: 16,
        },
      }
    }
  },
  [`${mainCls}__logo`]: {
    margin: '0 auto',
    [brpS]: {
      margin: 0,
      marginRight: '16px',
    }
  },
  [`${mainCls}__logo__img`]: {
    display: 'block',
    border: '1px solid #1a1f2410',
    objectFit: 'contain',
  },
  [`${mainCls}__logo__img--csa`]: {
    height: 28,
  },
  [`${mainCls}__logo__img--pm`]: {
    width: 100,
    height: 48,
  },
  [`${mainCls}__name`]: {
    marginTop: '16px',
    textAlign: 'center',
    [brpS]: {
      marginTop: 0,
      textAlign: 'left',
    }
  },
  [`${mainCls}__name--nomt`]: {
    marginTop: '0 !important',
  },
  [`${mainCls}__address`]: {
    lineHeight: '18px',
    textAlign: 'center',
    [brpS]: {
      textAlign: 'left',
      lineHeight: '16px',
      maxWidth: '365px',
    }
  },
  [`${mainCls}__logo-and-name`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    [brpS]: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      flexGrow: 1,
    }
  },
  [`${mainCls}__title-address`]: {
    [brpS]: {
      minWidth: '360px',
    }
  },

  [`${mainCls}__btns`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    marginTop: '16px',
    [brpS]: {
      marginTop: 0,
      flexDirection: 'row',
      flexWrap: 'nowrap',
      flexGrow: 1,
      justifyContent: 'space-between',
    }
  },
  [`${mainCls}__btns__link-a`]: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
    '&:hover': {
      borderColor: colors.secondary.rgba,
    },
    flexGrow: 1,
    marginRight: '0 !important',
    whiteSpace: 'wrap',
    [brpXS]: {
      whiteSpace: 'pre',
    },
    [brpS]: {
      maxWidth: '100%',
      marginBottom: 0,
    }
  },
  [`${mainCls}__btns__ghost`]: {
    display: 'flex',
    [brpS]: {
      flexGrow: 1,
      display: 'none',
    },
  },
  [`${mainCls}__btns__ghost-dsk`]: {
    display: 'none',
    [brpS]: {
      display: 'flex',
      flexGrow: 1,
    },
  },
  [`${mainCls}__btns__link-arrow-cnt`]: {
    display: 'flex',
    justifyContent: 'center',
    marginLeft: '2px',
    width: '16px',
    height: '16px',
  },
  [`${mainCls}__btns__link-arrow`]: {
    transform: 'rotate(-90deg)',
    '& path': {
      stroke: colors.secondary.rgba,
    },
  },

  [`${mainCls}__btns__contacts-btn`]: {
    display: 'flex !important',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#fff',
    '&:hover': {
      borderColor: colors.secondary.rgba,
    },
    '& .icon': {
      marginRight: 8,
    },
    '& .cnt': {
      display: 'flex !important',
      alignItems: 'center',
      opacity: 0,
      transition: 'opacity .3s cubic-bezier(0.075, 0.82, 0.165, 1)',
    },
    
  },
  [`${mainCls}__btns__contacts-reveal`]: {
    display: 'inline-block',
    width: 54,
    '&.revealed': {
      width: 'auto',
    },
  },
};
